/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { InvoiceService } from "@services";
import utils from "@utils";

import { Loader, Modal } from "../../../../../components";

import "./InternalNotesModal.scss";

const InternalNotesModal = props => {
	const { lang } = global;
	const { show, invoiceId, onHide, onSave } = props;

	const [internalNotesLoading, setInternalNotesLoading] = useState(false);
	const [internalNotes, setInternalNotes] = useState("");

	const getInternalNotesForNonRKPayInvoice = async () => {
		try {
			setInternalNotesLoading(true);
			const response = await InvoiceService.getInternalNotesForNonRKPayInvoice(invoiceId);
			setInternalNotes(response.data.Message);
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error getting invoice internal notes_"),
				timeOut: 1500,
			});
		} finally {
			setInternalNotesLoading(false);
		}
	};

	const handleOnSave = () => {
		setInternalNotesLoading(true);

		InvoiceService.putInternalNotesForNonRKPayInvoice(invoiceId, internalNotes)
			.then(() => {
				onSave();
				onHide();
			})
			.catch(() =>
				utils.notify({
					type: "error",
					message: lang.t("Error setting internal notes_"),
					timeOut: 1500,
				}),
			)
			.finally(() => setInternalNotesLoading(false));
	};

	useEffect(() => {
		if (show && invoiceId) {
			getInternalNotesForNonRKPayInvoice();
			return;
		}

		setInternalNotes(internalNotes);
	}, [show]);

	return (
		<Modal
			id="internal-notes-modal"
			show={show}
			onHide={() => onHide()}
		>
			<Modal.Header closeButton>
				<Modal.Title>{lang.t("Internal Notes")} </Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<textarea
					name="internalNotes"
					id="internalNotes"
					rows="6"
					className="form-control"
					placeholder="Enter notes"
					value={internalNotes}
					onChange={e => setInternalNotes(e.target.value)}
				/>
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					id="my-account-agency-info-save-btn"
					className="btn btn-primary"
					onClick={handleOnSave}
				>
					{lang.t("Done")}
				</button>
			</Modal.Footer>
			<Loader active={internalNotesLoading} />
		</Modal>
	);
};

InternalNotesModal.propTypes = {
	show: PropTypes.bool,
	onHide: PropTypes.func,
	invoiceId: PropTypes.string,
	onSave: PropTypes.func,
};

InternalNotesModal.defaultProps = {
	show: false,
	onHide: () => {},
	invoiceId: "",
	onSave: () => {},
};

export default InternalNotesModal;
